import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

export const getAllUsersFromMyMenuRequest = (token) => {
  const organizationId = localStorage.getItem("organizationId");
  const url = apiURl + "MyMenu/Users/organization/getAll/" + organizationId;

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

export const getAllDiscountsRequest = (token) => {
  const organizationId = localStorage.getItem("organizationId");
  const url = apiURl + "discounts/getall?organizationId=" + organizationId;

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

export const appendDiscountsRequest = (token, { data }) => {
  const url = apiURl + "discounts/user/add/";

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  };

  return fetchAndReturn(url, parameters);
};

export const removeDiscountsRequest = (token, { data }) => {
  const url = apiURl + "discounts/user/remove/";

  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  };

  return fetchAndReturn(url, parameters);
};

export const getDiscountsReferencesRequest = (token, startDate, endDate) => {
  const organizationId = localStorage.getItem("organizationId");
  const url =
    apiURl +
    `discounts/organization/${organizationId}?startDate=${startDate}&endDate=${endDate}`;

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};
